export default __webpack_public_path__ + "static/media/Card.ec68a4c9.svg";